import { useState } from 'react'
import { Col } from 'components/ui/Col'
import { Row } from 'components/ui/Row'
import { UIButton } from 'components/ui/Button'
import { useTranslation } from 'react-i18next'
import { useModal } from 'providers/ModalProvider'

type ConfirmDialogProps = {
  title: string
  description: string
  onConfirm: () => Promise<void>
  onSuccess?: () => void
}

export const ConfirmModal = ({ title, description, onConfirm, onSuccess }: ConfirmDialogProps) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const { close } = useModal()

  const handleConfirm = async () => {
    try {
      setLoading(true)
      await onConfirm()
      onSuccess?.()
      close()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Col className={'tw-shadow-md tw-rounded-lg tw-w-45 tw-primary-500 tw-p-4'}>
      <Row className={'tw-font-medium tw-text-xl'}>{title}</Row>
      <Row>{description}</Row>
      <Row className={'tw-mt-4 tw-gap-2'} width={'100%'}>
        <UIButton className={'tw-w-full tw-font-bold'} negative onClick={() => close()}>
          <span className={'tw-text-sm'}>{t('cancel')}</span>
        </UIButton>
        <UIButton className={'tw-w-full'} onClick={() => handleConfirm()} loading={loading}>
          <span className={'tw-text-sm'}>{t('confirm')}</span>
        </UIButton>
      </Row>
    </Col>
  )
}
